<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
<div>
  <p class="title-section">Estado de Mandriles de Inyección</p>
</div>
<table mat-table [dataSource]="mandrils" class="handover-data-table">
  <ng-container matColumnDef="numMandril">
      <mat-header-cell *matHeaderCellDef> Número de <br>Mandril </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index"> {{mandril.numMandril}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="tipoValvula">
      <mat-header-cell *matHeaderCellDef> Tipo de Válvula </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container>{{mandril.tipoValvula}}</ng-container>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="estadoMandril">
      <mat-header-cell *matHeaderCellDef> Estado de <br>Mandril </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container *ngIf="mandril.tipoValvula.includes('CIEGA')">CEGADO</ng-container>
          <ng-container *ngIf="mandril.tipoValvula.includes('SIN VRF')">LIBRE</ng-container>
          <ng-container *ngIf="!mandril.tipoValvula.includes('CIEGA') && !mandril.tipoValvula.includes('SIN VRF')">REGULADO</ng-container>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="profundidadTope">
      <mat-header-cell *matHeaderCellDef> MD Tope  <br>[m] </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container>{{mandril.profundidadTope | number: '1.2-2'}} </ng-container>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="profundidadBase">
      <mat-header-cell *matHeaderCellDef> MD Base  <br>[m] </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container>{{mandril.profundidadBase | number: '1.2-2'}} </ng-container>
      </mat-cell>
  </ng-container>
 
  <ng-container matColumnDef="ultimoVRF">
      <mat-header-cell *matHeaderCellDef> Estado de <br>Mandril </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container>{{mandril.ultimoVRF}}</ng-container>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef> Fecha del registro </mat-header-cell>
      <mat-cell *matCellDef="let mandril; let i = index">
          <ng-container>{{mandril.fecha | date: 'dd/MM/yyyy'}}</ng-container>
      </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let mandril; let i = index" [ngClass]="'mat-column-save'">
        <button mat-mini-fab (click)="openComments(mandrils[i], i, $event, readOnlyContent);" class="comment-ho-icon" name="openComments">
            <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
            <div class="circle-comments" *ngIf="mandrils[i].comments"></div>
            <span  class = "comment">Comentar</span>
        </button>
        <button mat-mini-fab (click)="save(mandrils[i], i);" class="save-ho-icon" [disabled]="isDisabled[i]" name="save">
            <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="9">
          <div class="footer">
              <div class="footer-no-data">No se encontraron datos.</div>
              <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
          </div>
      </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
</table>
